var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},[(_vm.isLoading)?_c('div',{staticClass:"loading-spinner level-item has-text-centered"},[_c('Spinner',{attrs:{"size":_vm.size}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }